/**
 * Servicio que conecta con la API las inspecciones de las incidencias
 */
InformeRestService.$inject = ['$resource'];

export default function InformeRestService($resource) {
    var urlBase = Sigo.url + '/api/v1' + '/informes' + '/:id';

    return $resource(urlBase, {
            id: '@id'
        }
    );
}